<template>
  <section>
    <Navbar />
    <main class="profile-page responsive-pad">
      <div class="workspace-heading">
        <div>
          <p class="eyebrow">Persönlicher Bereich</p>
          <h1>Mein Profil</h1>
        </div>
      </div>
      <section class="settings-card" aria-labelledby="profile-details-heading">
        <div class="settings-card-heading">
          <span class="settings-card-icon" aria-hidden="true">
            <font-awesome-icon :icon="['fas', 'id-badge']" />
          </span>
          <div>
            <h2 id="profile-details-heading">Persönliche Angaben</h2>
            <p class="section-description">Deine hinterlegten Kontakt- und Profildaten.</p>
          </div>
        </div>
        <dl class="profile-details">
          <div>
            <dt>{{ $t('profile.attention') }}</dt>
            <dd>{{ user.attention || 'Nicht hinterlegt' }}</dd>
          </div>
          <div>
            <dt>{{ $t('profile.mail') }}</dt>
            <dd>{{ user.u || 'Nicht hinterlegt' }}</dd>
          </div>
          <div>
            <dt>{{ $t('profile.name') }}</dt>
            <dd>{{ user.firstname || 'Nicht hinterlegt' }}</dd>
          </div>
          <div>
            <dt>{{ $t('profile.surname') }}</dt>
            <dd>{{ user.lastname || 'Nicht hinterlegt' }}</dd>
          </div>
        </dl>
      </section>
      <section class="settings-card" aria-labelledby="profile-security-heading">
        <div class="settings-card-heading">
          <span class="settings-card-icon" aria-hidden="true">
            <font-awesome-icon :icon="['fas', 'lock']" />
          </span>
          <div>
            <h2 id="profile-security-heading">Sicherheit</h2>
            <p class="section-description">
              Zum Ändern deines Passworts erhältst du einen Link per E-Mail.
            </p>
          </div>
        </div>
        <b-button class="primary-action" @click="forgot_pw">
          {{ $t('profile.change-password') }}
        </b-button>
      </section>
    </main>
    <Footer />
  </section>
</template>

<script>
import Navbar from '../components/Common/Navbar.vue';
import Footer from '../components/Common/Footer.vue';

export default {
  components: {
    Navbar,
    Footer,
  },

  computed: {
    user() {
      return this.$store.getters['User/user'];
    },
  },

  methods: {
    forgot_pw() {
      this.$buefy.dialog.confirm({
        title: this.$t('profile.change-password'),
        message: this.$t('profile.forgot-password-text'),
        confirmText: this.$t('profile.send-mail'),
        cancelText: this.$t('common.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('User/forgot_pw', this.user.u);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-page {
  padding-top: 32px;
  padding-bottom: 32px;
}
.profile-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px 32px;
  padding-top: 20px;
  border-top: 1px solid var(--theme-border);
  dt { color: var(--theme-text); font-size: .75rem; margin-bottom: 6px; }
  dd { margin: 0; color: var(--theme-text); font-size: .9375rem; overflow-wrap: anywhere; }
}
@media (max-width: 600px) {
  .profile-page { padding-top: 20px; padding-bottom: 20px; }
  .profile-details { grid-template-columns: 1fr; gap: 20px; }
}
</style>
